<template>
    <div class="layout-container">
        <el-tabs type="border-card" v-model="activeValue"  @tab-click="handleClick">
            <el-tab-pane label="主要栏目" name="1">
                <pageList type="1"></pageList>
            </el-tab-pane>
            <el-tab-pane label="楼盘条件页" name="2">
                <pageList type="2"></pageList>
            </el-tab-pane>
            <el-tab-pane label="楼盘页面" name="3">
                <pageList type="3"></pageList>
            </el-tab-pane>
            <el-tab-pane label="资讯页面" name="4">
                <pageList type="4"></pageList>
            </el-tab-pane>
            <el-tab-pane label="百科页面" name="5" v-if="host.indexOf('loushi')!=-1">
                <pageList type="5"></pageList>
            </el-tab-pane>
            <el-tab-pane label="房价页面" name="6">
                <pageList type="6"></pageList>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import pageList from './component/list'
    export default {

        components:{
            pageList
        },
        data(){
            return {
                activeValue:"1",
                host:""
            }
        },
        mounted(){
            const domain=document.domain
            this.host = window.serverConfig[window.siteMap[domain]].HOST
        },
        methods: {
            handleClick(tab, event) {
            },
        }
    }
</script>
<style scoped>

</style>